exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dynamic-delete-button{cursor:pointer;position:relative;top:4px;font-size:24px;color:#e96f6f;transition:all .3s}.dynamic-delete-button:hover{color:#f79494}.dynamic-delete-button[disabled]{cursor:not-allowed;color:#999;opacity:.5}.title{text-align:center}@media (max-width:768px){.add-time-button,.ant-calendar-picker,.submit-button{width:100%}.ant-checkbox-wrapper,.ant-radio-wrapper{display:block}.multiple-time-picker{width:calc(100% - 32px);margin-right:8px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/DoseForm/DoseForm.scss
// module id = 586
// module chunks = 0